import { Alert, Modal, Spin } from 'antd';
import type { ReleaseVersion } from '../../models/Release/releaseVersions';
import { formatReleaseDate } from '../../models/Release/releaseVersions';
import styles from './style.module.css';

export const RELEASE_ERROR =
  'Не удалось загрузить описание версии релиза. Пожалуйста, попробуйте позже';

interface Props {
  readonly open: boolean;
  readonly loading: boolean;
  readonly failed: boolean;
  readonly versions: readonly ReleaseVersion[];
  readonly onClose: () => void;
}

export const ReleaseHistoryModal = ({
  open,
  loading,
  failed,
  versions,
  onClose,
}: Props) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={680}
    centered
    rootClassName={styles.modalRoot}
    className={styles.modal}
    title={<span className={styles.srOnly}>История релизов</span>}
  >
    <div className={styles.releaseList} aria-busy={loading}>
      {loading ? (
        <div className={styles.loading} role="status">
          <Spin size="small" />
          <span>Загрузка описания релизов…</span>
        </div>
      ) : failed ? (
        <Alert type="error" showIcon message={RELEASE_ERROR} />
      ) : versions.length === 0 ? (
        <p role="status">Информация о релизах пока отсутствует</p>
      ) : (
        versions.map((release) => (
          <section className={styles.release} key={release.id}>
            <h2>Версия {release.version}</h2>
            {release.date && (
              <p className={styles.date}>
                от{' '}
                <time dateTime={release.date}>
                  {formatReleaseDate(release.date)}
                </time>
              </p>
            )}
            {release.descriptionItems.length > 0 && (
              <ul>
                {release.descriptionItems.map((item, index) => (
                  <li key={`${release.id}-${index}`}>{item}</li>
                ))}
              </ul>
            )}
          </section>
        ))
      )}
    </div>
  </Modal>
);
